var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.716 3.81a.857.857 0 01.713-.381h5.143c.287 0 .554.143.713.381L16.745 6h2.97a2.571 2.571 0 012.571 2.572V18a2.571 2.571 0 01-2.571 2.572H4.286A2.572 2.572 0 011.715 18V8.572A2.571 2.571 0 014.286 6h2.97l1.46-2.19zm1.172 1.333l-1.46 2.19a.857.857 0 01-.713.381H4.286a.857.857 0 00-.857.858V18a.857.857 0 00.857.857h15.429a.857.857 0 00.857-.857V8.572a.857.857 0 00-.857-.858h-3.429a.857.857 0 01-.713-.381l-1.46-2.19H9.888z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.286a2.571 2.571 0 100 5.142 2.571 2.571 0 000-5.142zm-4.285 2.571a4.286 4.286 0 118.571 0 4.286 4.286 0 01-8.571 0z"
  })));
}
export default SvgCamera;